import React from 'react';
import {
    ProjectsHeader,
    // SectionTitle,
    HeaderButtons,
    AddProjectButton,
    // MenuButton,
    // SearchInput, // Will be removed
    // FilterDropdown // Will be removed
} from '../../styles/Dashboard.styles';
import CombinedSearchFilter from './CombinedSearchFilter'; // Import new component
import styled from 'styled-components'; // For the wrapper

// Wrapper to handle positioning of the new component
const SearchFilterWrapper = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    min-width: 200px; // Ensure it has some minimum width, adjust as needed

    @media (max-width: 768px) { // Or a breakpoint where wrapping is expected
        margin-left: 0; // Reset margin
        width: 100%;    // Take full width
        order: 1;       // Optional: if you want it to appear last when wrapped
        margin-top: 8px; // Add some space if it wraps below other buttons
    }
`;

const filterOptions = ["All", "Title", "Description", "Checklist", "URL"];

function DashboardHeader({
    setIsModalOpen,
    setCreateWorkspaceModalOpen,
    setIsSidebarOpen,
    setIsAddBookmarkModalOpen,
    setIsIframeModalOpen,
    setIsAddSaveModalOpen,
    searchQuery,
    setSearchQuery,
    searchFilter,
    setSearchFilter
}) {
    return (
        <ProjectsHeader>
            {/* <SectionTitle>Projects</SectionTitle> */}
            <HeaderButtons>
                {/* Action buttons remain on the left */}
                <AddProjectButton onClick={() => setIsModalOpen(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Project
                </AddProjectButton>
                <AddProjectButton onClick={() => setCreateWorkspaceModalOpen(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Workspace
                </AddProjectButton>
                <AddProjectButton onClick={() => setIsAddBookmarkModalOpen(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Bookmark
                </AddProjectButton>
                <AddProjectButton onClick={() => setIsAddSaveModalOpen(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    Save
                </AddProjectButton>

                {/* New Combined Search Filter on the right */}
                <SearchFilterWrapper>
                    <CombinedSearchFilter
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        searchFilter={searchFilter}
                        setSearchFilter={setSearchFilter}
                        filterOptions={filterOptions}
                    />
                </SearchFilterWrapper>

                {/* <MenuButton onClick={() => setIsSidebarOpen(true)}>
                    <MenuIcon />
                </MenuButton> */}
            </HeaderButtons>
        </ProjectsHeader>
    );
}

export default DashboardHeader;
